import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiAuthTokens, ApiLoginRequest, ApiLoginResponse, ApiRefreshRequest } from '@core/models/api/auth.model';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}/auth`;

  login(payload: ApiLoginRequest): Observable<ApiLoginResponse> {
    return this.http.post<ApiLoginResponse>(`${this.baseUrl}/login`, payload);
  }

  refresh(payload: ApiRefreshRequest): Observable<ApiAuthTokens> {
    return this.http.post<ApiAuthTokens>(`${this.baseUrl}/refresh`, payload);
  }
}
